import { Box, Button, Flex, Grid, NumberInput, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconCheck } from "@tabler/icons-react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";

interface TechnicalConfigurationModel {
  id: string | null;
  name: string | null;
  attr1: number | null;
  attr2: number | null;
  attr3: number | null;
  attr4: number | null;
  attr5: number | null;
  attr6: string | null;
  attr7: string | null;
  attr8: string | null;
  attr9: string | null;
  attr10: string | null;
  createDate: string | null;
  createBy: number | null;
}

const CreateTechnicalConfiguration = ({ onSuccess }: { onSuccess: any }) => {
  const form = useForm<TechnicalConfigurationModel>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      id: null,
      name: null,
      attr1: null,
      attr2: null,
      attr3: null,
      attr4: null,
      attr5: null,
      attr6: null,
      attr7: null,
      attr8: null,
      attr9: null,
      attr10: null,
      createDate: null,
      createBy: null,
    },

    validate: {},
  });

  const handleCreateTechnicalConfiguration = async (
    dataSubmit: TechnicalConfigurationModel
  ) => {
    const res = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/TestingTechniqueTime/create",
      dataSubmit
    );

    if (res && res.success) {
      NotificationExtension.Success(
        "Tạo mới cấu hình kỹ thuật cho giao vận thành công !"
      );
      setTimeout(() => {
        modals.closeAll();
        onSuccess();
      }, 1000);
    }
  };

  return (
    <Box
      component="form"
      w={"20vw"}
      maw={350}
      pt={10}
      onSubmit={form.onSubmit((e: TechnicalConfigurationModel) =>
        handleCreateTechnicalConfiguration(e)
      )}
    >
      <Grid>
        <Grid.Col span={12}>
          <TextInput
            key={form.key("name")}
            label={"Tên loại KT"}
            placeholder="Nhập tên loại kỹ thuật"
            {...form.getInputProps("name")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <NumberInput
            key={form.key("attr1")}
            label="Thời gian"
            placeholder="Nhập thời gian"
            hideControls
            allowNegative={false}
            suffix=" phút"
            {...form.getInputProps("attr1")}
          />
        </Grid.Col>
      </Grid>
      <Flex justify={"center"} align={"center"} mt={5}>
        <Button
          leftSection={<IconCheck size={14} />}
          color="teal"
          type="submit"
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default CreateTechnicalConfiguration;
